<template>
  <div v-cloak>
    <h1 class="breadcrumbTitle">{{currentSelectName}}</h1>
    <el-breadcrumb style='' separator="/">
      <el-breadcrumb-item :to="{ path: item.path }" v-for="(item,index) in mbRouter" :key="index">
        {{ item.name }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>

</template>
<style scoped>
  [v-cloak] {
    display: none;
  }
  .breadcrumbTitle {
    color:#48576A;
    background: none;
    margin-top:14px;
    font-size: 24px;
    /*font-weight: bold;*/
  }
</style>
<script>
  export default{
    data(){
      return {
        mbRouter: null,
        currentSelectName: null
      }
    },
    watch: {
      $route () {
        var that = this
        that.initMbRouter(that.$route.matched)
      }
    },
    props: ['matched'],
    mounted () {
      var that = this
      that.initMbRouter(that.$route.matched)
    },
    methods:{
      initMbRouter (matched) {
        var that = this
//        that.mbRouter = this.$route.matched;
        that.mbRouter = matched;
        that.mbRouter = that.mbRouter.filter((r)=>{
          if (!r.name) {
            return false
          } else {
            return true
          }
        })



        var sl = that.mbRouter[that.mbRouter.length-1]
        that.currentSelectName = sl.name
      }
    }
  }
</script>



// WEBPACK FOOTER //
// breadcrumb.vue?a5cae9d8